{
  "_meta": {
    "_comment": "Phase 14.1 Wave 8 Task 40 — merchant orders namespace (embroidery 2-step accept dialog). vg-binding: P14.1.D-04 / P14.1.D-18 / INTERFACE-STANDARDS:error-shape",
    "locale": "fr"
  },
  "embAccept": {
    "title": "Frais de broderie en attente d'approbation",
    "titleWithOrder": "Frais de broderie en attente — Commande {{orderNumber}}",
    "subtitle": "Les frais sont calculés d'après le nombre réel de points du fichier numérisé.",
    "deadlineBadge": "Il reste {{remaining}}",
    "deadlineTooltip": "Sans acceptation sous 72 heures, la commande est auto-annulée et intégralement remboursée.",
    "deadlineAt": "Répondez avant le {{deadline}}",
    "colArtwork": "Visuel / face",
    "colPosition": "Position",
    "colStitches": "Points",
    "colFee": "Frais",
    "positionFirst": "Première",
    "positionSubsequent": "Suivante",
    "total": "Total des frais de broderie",
    "acceptButton": "Accepter les frais de broderie {{amount}}",
    "accepting": "Traitement…",
    "cancel": "Annuler",
    "autoCancelNote": "Sans réponse sous 72 heures : la commande est auto-annulée et le montant intégral est remboursé sur votre portefeuille. Cette action est idempotente (protégée contre les soumissions en double).",
    "success": "Frais de broderie acceptés.",
    "networkFallback": "Erreur réseau - vérifiez la connexion",
    "remaining": {
      "expired": "Délai dépassé",
      "hoursMinutes": "{{hours}} h {{minutes}} min",
      "minutes": "{{minutes}} min"
    },
    "errors": {
      "notPending": "Ces frais ne sont plus en attente — la fenêtre va être actualisée.",
      "quoteMismatch": "Les frais ont changé depuis le chargement — vérifiez le détail mis à jour.",
      "walletInsufficient": "Le solde de votre portefeuille est insuffisant — rechargez pour accepter ces frais."
    }
  },
  "payBulk": {
    "resultPaidList": "Payées : {{list}}",
    "resultSkippedHeading": "Ignorées ({{n}}) — ces commandes n'ont pas été débitées :",
    "toast": {
      "payBulkSummary": "{{paidCount}} payée(s), {{skippedCount}} ignorée(s) — {{totalDebited}} débités.",
      "payBulkInvalid": "Le paiement groupé n'a pas pu être envoyé. Vérifiez votre sélection et réessayez."
    },
    "reason": {
      "PRICE_CHANGED": "Le prix a changé — demandez un nouveau devis",
      "SHIPPING_CHANGED": "Les frais de livraison ont changé — demandez un nouveau devis",
      "TAX_CHANGED": "Le taux de taxe a changé — demandez un nouveau devis",
      "EXPIRED": "Devis expiré — demandez un nouveau devis",
      "CART_CHANGED": "Le contenu de la commande a changé — vérifiez la commande puis demandez un nouveau devis",
      "CONSUMED": "Déjà payée — cette commande a été débitée précédemment",
      "MISSING_SNAPSHOT": "Aucun devis valide sur cette commande — demandez un nouveau devis",
      "QUOTE_STALE": "Le devis n'est plus à jour — demandez un nouveau devis",
      "WALLET_INSUFFICIENT": "Solde insuffisant — rechargez puis réessayez",
      "SHIPPING_UNAVAILABLE": "Aucun service de livraison ne dessert cette destination — ouvrez la commande pour la modifier",
      "PRICING_MISMATCH": "Erreur de tarification — rien n'a été débité, veuillez réessayer",
      "IDEMPOTENCY_KEY_REUSE": "Cette commande a changé depuis le début du lot — rechargez puis réessayez",
      "ORDER_FORBIDDEN": "Vous n'avez plus accès à cette commande",
      "ORDER_NOT_FOUND": "Cette commande n'existe plus"
    }
  }
}
